<template>
  <!-- 栏目管理 -->
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="text">{{ title }}</div>
      </div>
      <div class="content flex flexJc-c">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="90px"
          size="medium"
        >
          <el-form-item label="栏目名：" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="路径：" prop="url">
            <el-input v-model="form.url"></el-input>
          </el-form-item>
          <el-form-item label="上级栏目：" prop="parentId">
            <el-select
              class="width100"
              v-model="form.parentId"
              placeholder="选择栏目"
              @click.native="selectClick"
            >
              <el-option label="无上级栏目" value="0"> </el-option>
              <el-option
                v-for="item in parentOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="SubmitLoad"
              @click="onSubmit('form')"
              >确定</el-button
            >
            <el-button @click="cancelClick">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFindLevelOne } from '@/api/share'
import { apiAddNavigation } from '@/api/backgroundViews'
let that
export default {
  name: '',
  props: [''],
  data() {
    return {
      form: {
        name: '',
        parentId: '0',
        url: ''
      },
      title: '添加栏目',
      rules: {
        name: [{ required: true, message: '请输入栏目名', trigger: 'blur' }],
        url: [{ required: true, message: '请输入路径地址', trigger: 'blur' }]
      },
      parentOptions: [], // 上级栏列表
      SubmitLoad: false
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    that = this
    // 判断是否是编辑过来的
    if (this.objNull(this.$route.query) === false) {
      this.form.name = this.$route.query.name
      this.form.url = this.$route.query.url
      if (this.$route.query.parentId === null) {
        this.form.parentId = '0'
      } else {
        this.FindLevelOne()
        this.form.parentId = this.$route.query.parentId
      }
      this.title = '编辑栏目'
    }
    console.log(this.$route.query)
  },

  methods: {
    //
    // 提交
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let lv
          let parentId
          if (this.form.parentId === '0') {
            lv = '0'
            parentId = ''
          } else {
            lv = '1'
            parentId = this.form.parentId
          }
          this.SubmitLoad = true
          apiAddNavigation({
            id: this.$route.query.id,
            name: this.form.name,
            lv: lv,
            url: this.form.url,
            parentId: parentId
          }).then(res => {
            if (res.status === '0') {
              this.$Ms(res.msg)
              that.$refs[formName].resetFields()
              this.$router.go(-1)
            } else if (res.status === '1') {
              this.$Me(res.msg)
            }
            this.SubmitLoad = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 取消
    cancelClick() {
      this.$router.go(-1)
    },
    // 点击栏目
    selectClick() {
      this.FindLevelOne()
    },
    /* 接口 */
    // 查找一级目录的导航栏
    FindLevelOne() {
      apiFindLevelOne().then(res => {
        if (res.status === '0') {
          this.parentOptions = res.data
          console.log(this.parentOptions)
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$colorMajor: #018b43;
.vue {
  padding: 10px;
  background-color: #fff;
  border-left: 2px solid $colorMajor;
  .header {
    border-bottom: 1px solid #d5d5d5;
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: $colorMajor;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    .el-form {
      padding: 20px 0;
      width: 60%;
    }
  }
}
</style>
